import React, { Fragment, useState, useEffect, useContext } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import {
  FilterSideBar,
  LoadingIndicator,
  NoAccessScreen,
} from "../../../../Component";
import { searchCheckRequests } from "../../../../API/Check";
import { ChecksTable, PageHeader, CancelChecks } from "..";
import AllocateRequest from "../../../DetailedRecord/Component/AllocateRequest";
import withUserDetails from "../../../../HOC/withUserDetails";
import { recordTypes } from "../../../../API/config";
import { getAttributeValue } from "../../../../Utilities/Functions";
import { styles } from "./styles";

const ChecksRequests = (props) => {
  const { classes, user, hasPermission, hasRecordPermission } = props;

  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [checkRequests, setCheckRequests] = useState([]);
  const [totals, setTotals] = useState(0);
  const [fetchData, setFetchData] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState();
  const [canSearch, setCanSearch] = useState();
  const [canCreate, setCanCreate] = useState();

  const [openAllocationDialog, setOpenAllocationDialog] = useState(false);
  const [openCancelCheckDialog, setOpenCancelCheckDialog] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState({
    checkTypes: ["KYC", "AML"],
    requestedByMe: true,
  });

  const { showErrorMessage } = useContext(ModalDialogContext);

  useEffect(() => {
    //set from filter
    //setFetchData(true);
    setLoading(true);
  }, []);

  useEffect(() => {
    const evalPermissions = async () => {
      const canSearch = await hasPermission(
        recordTypes.checkRequest.name,
        recordTypes.checkRequest.actions.search.name,
      );
      setCanSearch(canSearch);
      const canCreateKyc = await hasPermission(
        recordTypes.checkRequest.name,
        recordTypes.checkRequest.actions.createKycCheck.name,
      );
      const canCreateAml = await hasPermission(
        recordTypes.checkRequest.name,
        recordTypes.checkRequest.actions.createAmlCheck.name,
      );
      setCanCreate(canCreateKyc || canCreateAml);
    };

    const loadChecks = async () => {
      setLoading(true);
      try {
        const results = await searchCheckRequests({
          pageNumber,
          rowsPerPage,
          searchCriteria,
        });
        const { data } = results || {};
        const { records, totals } = data || {};
        setCheckRequests(records.map(convertToTableData));
        setTotals(totals);
      } catch (error) {
        showErrorMessage({ error });
      }
      setLoading(false);
      setFetchData(false);
    };

    evalPermissions();
    if (fetchData) {
      loadChecks();
    }
  }, [fetchData]);

  if (!loading && !canSearch) {
    return <NoAccessScreen />;
  }

  const handlePagination = async (pageNumber) => {
    setPageNumber(pageNumber);
    // setRowsPerPage(30);
    setFetchData(true);
  };

  const handleRowsPerPageChange = async (rows) => {
    setRowsPerPage(rows);
    setFetchData(true);
  };

  const convertToTableData = (checRequest) => {
    const {
      id,
      check_type: checkType,
      process_flow_state: processState,
      country_name: jllCountry,
      allocated_user_name,
      created_by_user_name: requestor,
      country_iso_code_3,
      entity,
      cancelled,
      permissions,
      allocated_user_email,
    } = checRequest;
    const { attributes, entity_category: recordType, id: entityId } = entity;
    const attributesObj = attributes.reduce(function (attrs, attr) {
      attrs[attr.name] = getAttributeValue(attr);
      return attrs;
    }, {});

    const canView = hasRecordPermission(
      permissions,
      recordTypes.record.actions.view.name,
    );
    const canAllocate = hasRecordPermission(
      permissions,
      recordTypes.checkRequest.actions.allocate.name,
    );
    const isComplete =
      processState === "Approved" ||
      processState === "Proceed At Risk" ||
      processState === "Rejected" ||
      processState === "Expired";

    const isExpired = processState === "Expired";
    const canCancel =
      !isComplete &&
      !cancelled &&
      hasRecordPermission(
        permissions,
        recordTypes.checkRequest.actions.cancel.name,
      );

    let canRestart = false;
    if (isComplete) {
      canRestart =
        isExpired &&
        !cancelled &&
        hasRecordPermission(
          permissions,
          recordTypes.checkRequest.actions.restartCompleted.name,
        );
    } else if (cancelled) {
      canRestart = hasRecordPermission(
        permissions,
        recordTypes.checkRequest.actions.restartCancelled.name,
      );
    }

    return {
      id,
      checkType,
      processState,
      name: attributesObj["Full name"],
      country: attributesObj["Country of operations"],
      recordType,
      jllCountry,
      requestor,
      entityId,
      country_iso_code_3,
      assigned: allocated_user_name ? allocated_user_name : "Unassigned",
      allocated_user_email,
      allocated_user_name,
      cancelled,
      canView,
      canAllocate,
      canCancel,
      canRestart,
    };
  };

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const renderTable = () => {
    if (loading) {
      return <Fragment>{renderLoadingIndicator()}</Fragment>;
    } else {
      return (
        <ChecksTable
          data={checkRequests}
          totalItemsCount={totals.totalCount}
          rowsPerPage={rowsPerPage}
          pageNumber={pageNumber}
          handlePagination={handlePagination}
          onReqestAllocationClick={openRequestAllocationDialog}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handelCancelCheck={openCancelDialog}
        />
      );
    }
  };

  const onSearchCriteriaChange = async (newSearchCriteria) => {
    setSearchCriteria({ ...searchCriteria, ...newSearchCriteria });
    setFetchData(true);
  };

  const openRequestAllocationDialog = (request) => {
    setSelectedRequest(request);
    setOpenAllocationDialog(true);
  };

  const onAllocationClose = async () => {
    setOpenAllocationDialog(false);
  };

  const onAllocationSubmit = async () => {
    setOpenAllocationDialog(false);
    setFetchData(true);
  };

  const openCancelDialog = async (request) => {
    setSelectedRequest(request);
    setOpenCancelCheckDialog(true);
  };

  const closeCancelDialog = async (submtted) => {
    if (submtted) {
      setFetchData(true);
    }
    setOpenCancelCheckDialog(false);
  };

  return (
    <Grid container>
      <Grid container className={classes.bodyContainer}>
        <Grid item xs={4} sm={4} md={3} lg={2}>
          <FilterSideBar
            nameFilter={true}
            checkFilter={true}
            countryFilter={true}
            scoreFilter={false}
            requestAgeFilter={true}
            myChecksFilter={true}
            checkStatusFilter={true}
            user={user}
            defaultUserCountry={true}
            onSearchCriteriaChange={onSearchCriteriaChange}
          />
        </Grid>
        <Grid item xs={8} sm={8} md={9} lg={10}>
          <Grid container>
            <Grid item xs={12}>
              <PageHeader totals={totals} canCreate={canCreate} user={user} />
            </Grid>
            <Grid item xs={12}>
              {renderTable()}

              {openAllocationDialog && (
                <AllocateRequest
                  isOpen={openAllocationDialog}
                  request={selectedRequest}
                  user={user}
                  onClose={onAllocationClose}
                  onSubmit={onAllocationSubmit}
                ></AllocateRequest>
              )}

              {openCancelCheckDialog && (
                <CancelChecks
                  isOpen={openCancelCheckDialog}
                  entityId={selectedRequest.entityId}
                  hasPermission={hasPermission}
                  hasRecordPermission={hasRecordPermission}
                  onClose={closeCancelDialog}
                ></CancelChecks>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withUserDetails(
  withStyles(styles, { withTheme: true })(ChecksRequests),
);
